import type { NavigationGuardNext, RouteRecordNormalized } from "vue-router"
import {$auth} from "@/plugins/auth"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"
import {roles} from "@/enums/roles"

export default class NotAccountOwner implements App.Middleware.Instance {
  async handle(
    to: RouteRecordNormalized,
    from: RouteRecordNormalized,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user!.role !== roles.ACCOUNT_OWNER) {
      return next(to, from, cancel)
    }

    return cancel(route(ROUTES.CALENDAR))
  }
}
